var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWineGlassCrack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M272.024 504C272.024 508.375 268.399 512 264.022 512H55.979C51.602 512 47.977 508.375 47.977 504C47.977 481.875 65.856 464 87.985 464H127.995V346.875C59.479 330.875 9.969 266.875 16.594 192.625L32.473 14.5C33.223 6.25 40.1 0 48.227 0H133.827L166.71 48.25L81.19 104.25L202.717 224L153.206 119.75L238.725 63.75L208.217 0H271.774C279.901 0 286.778 6.25 287.528 14.5L303.407 192.625C310.032 266.875 260.522 330.875 192.006 346.75V464H232.016C254.145 464 272.024 481.875 272.024 504Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWineGlassCrack);
export default __webpack_public_path__ + "static/media/wine-glass-crack.d03a94873f7cf250bb77e875c3b4823e.svg";
export { ForwardRef as ReactComponent };